<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('create')}} {{t('assessment')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/assessments" class="d-inline-block position-relative">
                    {{t('Management')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('create')}} {{t('assessment')}}
            </li>
        </ol>
    </div>

    <!-- Create Assessment -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="addAssessmentForm">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" id="assessmentName" formControlName="assessmentName"
                                    required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('description')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-description')}}
                                </mat-label>
                                <input matInput type="text" id="description" formControlName="description">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('severity')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-severity')}}
                                </mat-label>
                                <mat-select name="severity" formControlName="severity" required>
                                    <mat-option *ngFor="let severity of severities" [value]="severity">
                                        {{severity.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('enter-a-date-range')}}
                            </label>
                            <mat-form-field>
                                <mat-date-range-input [formGroup]="addAssessmentForm" [rangePicker]="picker">
                                    <input matStartDate formControlName="startDate" placeholder="{{t('start-date')}}">
                                    <input matEndDate formControlName="endDate" placeholder="{{t('end-date')}}">
                                </mat-date-range-input>
                                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                @if (addAssessmentForm.get('startDate')!.hasError('matStartDateInvalid')) {
                                <mat-error>{{t('invalid-start-date')}}</mat-error>
                                }
                                @if (addAssessmentForm.get('endDate')!.hasError('matEndDateInvalid')) {
                                <mat-error>{{t('invalid-end-date')}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-company')}}
                                </mat-label>
                                <mat-select [(value)]="selectedCompany"
                                    (selectionChange)="changeCompany(selectedCompany)" required>
                                    <mat-option *ngFor="let company of companies" [value]="company.id">
                                        {{company.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('branch-office')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-branch-office')}}
                                </mat-label>
                                <mat-select formControlName="branchOffice" [(value)]="selectedBranchOffice"
                                    (selectionChange)="changeBranchOffice()" required>
                                    <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice">
                                        {{branchOffice.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('vulnerability-origin')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-vulnerability-origin')}}
                                </mat-label>
                                <mat-select formControlName="vulnerabilityOrigin"
                                    [(value)]="selectedVulnerabilityOrigin">
                                    <mat-option *ngFor="let vulnerabilityOrigin of vulnerabilityOrigins"
                                        [value]="vulnerabilityOrigin">
                                        {{vulnerabilityOrigin.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('vulnerability-tool')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-vulnerability-tool')}}
                                </mat-label>
                                <mat-select formControlName="vulnerabilityTool" [(value)]="selectedVulnerabilityTool">
                                    <mat-option>{{t('none')}}</mat-option>
                                    <mat-option *ngFor="let vulnerabilityTool of vulnerabilityTools"
                                        [value]="vulnerabilityTool">
                                        {{vulnerabilityTool.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="addAssessmentForm.get('vulnerabilityTool')!.hasError('required')">
                                {{t('field-required')}}
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('upload-file')}}
                            </label>
                            <file-upload class="file-uploader" [multiple]="false" accept=".zip, .csv"
                                formControlName="file"></file-upload>
                            <mat-error *ngIf="addAssessmentForm.get('file')!.hasError('required')">
                                {{t('field-required')}}
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company-users-list')}}
                            </label>
                            <mat-selection-list formControlName="companyUsers" #usersList>
                                @for (companyUser of companyUsersList; track companyUser) {
                                <mat-list-option value="{{companyUser.id}}">{{companyUser.name}}</mat-list-option>
                                }
                            </mat-selection-list>
                            <p>
                                {{t('company-users-selected')}}: {{usersList.selectedOptions.selected.length}}
                            </p>
                        </div>
                    </div>
                </div>
                @if (isLoadingSubmit) {
                <mat-spinner></mat-spinner>
                }
                <div class="btn-box">
                    <button mat-button type="button" (click)="onSubmit()" [disabled]="addAssessmentForm.invalid || isLoadingSubmit">
                        {{t('create')}} {{t('assessment')}}
                    </button>
                    <a mat-button routerLink="/vulnerability/assessments">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
